import { render, staticRenderFns } from "./TheOrganizationDetails.vue?vue&type=template&id=289d1249&"
import script from "./TheOrganizationDetails.vue?vue&type=script&lang=js&"
export * from "./TheOrganizationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports